import React, {useEffect} from 'react';
import Cookies from 'js-cookie';
import useDocusaurusContext from "@docusaurus/useDocusaurusContext";
import * as Sentry from "@sentry/react";

export default function Root({ children }) {
    const { siteConfig } = useDocusaurusContext();
    const url = siteConfig.url;

    useEffect(() => {
        // Funkcja do wyodrębnienia domeny głównej z URL
        const getCookieDomain = (url) => {
            try {
                const parsedUrl = new URL(url);
                const hostname = parsedUrl.hostname;

                // Sprawdzenie, czy nie jesteśmy na localhost lub podobnym środowisku
                if (hostname === 'localhost' || hostname === '127.0.0.1') {
                    return undefined; // Nie ustawiamy domeny ciasteczka, działa tylko dla bieżącej domeny
                }

                // Dla subdomen, ustawiamy ciasteczko na główną domenę
                const domainParts = hostname.split('.');
                if (domainParts.length > 2) {
                    // Przykład: sub1.pdfbolt.com -> .pdfbolt.com
                    const mainDomain = `.${domainParts.slice(-2).join('.')}`;
                    return mainDomain;
                }

                // Jeśli nie ma subdomen, zwracamy hostname bez zmian
                return hostname;
            } catch (error) {
                console.error('Invalid URL:', url);
                return undefined;
            }
        };

        const cookieDomain = getCookieDomain(url);

        // Sprawdzamy, czy nie mamy jeszcze zapisanej wartości initialSource w ciasteczkach
        if (!Cookies.get('initialSource')) {
            const referrer = document.referrer;
            // Jeżeli referrer jest spoza naszej domeny (czyli user przyszedł z zewnątrz)
            if (referrer && !referrer.includes(window.location.hostname)) {
                Cookies.set('initialSource', referrer, {
                    domain: cookieDomain, // Dynamicznie ustawiona domena
                    path: '/',
                    secure: window.location.protocol === 'https:', // Używamy Secure tylko jeśli HTTPS
                    sameSite: 'Lax', // Możesz dostosować zgodnie z potrzebami
                });
            } else {
                // Brak referrera (np. wejście bezpośrednie, otwarie w nowej karcie, etc.)
                Cookies.set('initialSource', 'direct', {
                    domain: cookieDomain,
                    path: '/',
                    secure: window.location.protocol === 'https:',
                    sameSite: 'Lax',
                });
            }
        }

        // Obsługa parametru gclid z URL dla Google Ads tracking
        if (!Cookies.get('gclid')) {
            const urlParams = new URLSearchParams(window.location.search);
            const gclid = urlParams.get('gclid');
            if (gclid) {
                Cookies.set('gclid', gclid, {
                    domain: cookieDomain,
                    path: '/',
                    secure: window.location.protocol === 'https:',
                    sameSite: 'Lax',
                    expires: 90 // Google Ads conversion tracking window is typically 30-90 days
                });
            }
        }
    }, [url]); // Dodajemy `url` jako zależność, aby efekt był aktualizowany, jeśli `url` się zmieni

    return (
        <Sentry.ErrorBoundary fallback={<p>Something went wrong. Please refresh the page.</p>}>
            {children}
        </Sentry.ErrorBoundary>
    );
}
